import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import axios from "axios";
import { routes } from "../General";

export const ModalPrint = ({
    alert,
    open,
    setOpen,
    cdCompania,
    cdCotizacion,
    cdRamoCotizacion,
    vam,
    pdf,
    aseg,
    poliza,
}) => {
    const [linkPdf, setLinkPdf] = useState("");
    const [error, setError] = useState(false);
    const [msm, setMsm] = useState("Generando... Por favor espere...");

    useEffect(() => {
        if (open) {
            setError(null);

            if (linkPdf) {
                window.URL.revokeObjectURL(linkPdf);
            }
            getPdf(cdCompania, cdCotizacion, cdRamoCotizacion, vam, pdf, aseg, poliza);
        } else {
            window.URL.revokeObjectURL(linkPdf);
            setLinkPdf(null);
        }
        return () => {
            if (linkPdf) {
                window.URL.revokeObjectURL(linkPdf);
            }
        };
    }, [open, cdCotizacion, cdCotizacion, vam, pdf, aseg, poliza]);

    function getPdf(cdCompania, cdCotizacion, cdRamoCotizacion, vam, pdf, aseg, poliza) {
        axios
            .get(routes.api + "/poliza/reporte/print", {
                params: {
                    cdCompania,
                    cdCotizacion,
                    cdRamoCotizacion,
                    vam,
                    pdf,
                    aseg,
                    poliza,
                },
                responseType: "blob",
            })
            .then(res => {
                let linkPdf = window.URL.createObjectURL(res.data);
                if (!pdf) {
                    setMsm("Su reporte se ha descargado con éxito, revise su carpeta de Descargas");
                    setTimeout(() => {
                        setLinkPdf(linkPdf);
                        setOpen(false);
                    }, 4000);
                } else {
                    setLinkPdf(linkPdf);
                }
            })
            .catch(error => {
                setError(true);
                alert.handle_error(error);
            });
    }

    return (
        <Modal className="text-center modal-print" isOpen={open} size={"xl"}>
            <ModalHeader className="justify-content-center title py-1" tag="h6">
                Reporte
                <button
                    type="button"
                    className="close py-0"
                    title="Cerrar"
                    onClick={() => setOpen(false)}
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </ModalHeader>
            <ModalBody className="py-1">
                <div className="col-12">
                    {linkPdf && (
                        <iframe
                            title="iframe"
                            className="w-100"
                            src={linkPdf}
                            style={{ height: "calc(100vh - 300px)" }}
                        />
                    )}

                    {!linkPdf && !error && <div>{msm}</div>}
                    {error && <span>Error al generar contacte con soporte.</span>}
                </div>
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-secondary" onClick={() => setOpen(false)}>
                    Cerrar
                </button>
            </ModalFooter>
        </Modal>
    );
};
